export function AceClubs(done: boolean) {
  return (
    <svg
      version="1.1"
      viewBox="0 0 1475 2048"
      width="fit-content"
      height="197"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path transform="translate(0)" d="m0 0h1475v2048h-1475z" fill="#FEFEFE" />
      <path
        transform="translate(0)"
        d="m0 0h1475v2048h-1475zm98 42-14 2-12 5-11 8-7 9-7 14-2 10v1867l2 11 8 16 6 7 13 9 10 4 5 1 1191 1h85l15-1 13-4 11-7 9-9 7-12 3-10 1-9v-1860l-2-14-8-16-12-12-16-8-14-2z"
        fill="#FEFEFE"
      />
      <path
        transform="translate(721,857)"
        d="m0 0h27l17 5 12 6 13 9 9 10 8 11 6 12 3 9 1 9 1 7v11l-2 13-4 13-7 14-10 12-5 5-7 5 14-4 9-2h22l15 3 16 7 11 8 14 14 8 13 5 11 4 18v20l-4 17-8 16-7 11-11 11-14 9-18 7-12 2h-22l-14-4-13-5-14-10-10-9-4-7-1 57-28 1-1-1-1-56-11 13-13 9-16 8-6 2-12 2h-21l-17-4-17-9-11-8-9-9-7-11-6-12-4-15-1-5v-21l4-17 6-14 8-11 15-15 15-9 14-5 11-2h19l16 3 12 5-11-8-8-9-6-9-7-14-4-15-1-6v-17l4-18 9-19 10-13 8-7 6-5 16-8 12-4z"
        fill="#010101"
      />
      <path
        transform="translate(98,42)"
        d="m0 0h1274l14 2 16 8 12 12 8 16 2 14v1860l-2 13-5 12-7 9-7 7-10 6-13 4-15 1h-85l-1191-1-13-4-11-7-5-5-7-8-6-13-2-11v-1867l2-10 8-16 7-8 10-7 12-5zm-6 3-12 3-11 6-9 8-8 13-3 8-1 6v1868l2 11 6 12 9 10 9 7 9 4 14 2h1274l14-2 9-4 9-6 8-8 6-11 3-10 1-8v-1862l-2-11-4-9-6-9-9-9-14-7-10-2z"
        fill="#414141"
      />
      {done && (
        <path
          transform="translate(152,87)"
          d="m0 0 5 1 5 16 13 50 11 41 15 57-1 3h-20l-3-3-7-28-1-2-47-1-4 18-5 15-2 1h-13l-8-1 11-43 9-33 22-84 1-6z"
          fill="#050505"
        />
      )}
      {done && (
        <path
          transform="translate(1268,1793)"
          d="m0 0h22l3 7 6 24 1 2 47 1 4-18 4-14 2-2h21l-1 9-25 95-10 36-7 27h-23l-5-16-15-57-15-56-9-35z"
          fill="#040404"
        />
      )}
      {done && (
        <path
          transform="translate(1322,1644)"
          d="m0 0h9l1 1v18l5-6 8-4 4-1h10l10 3 8 8 4 8 1 4v9l-3 8-6 9-8 5-2 1h-18l6 7 3 8v14l-5 10-10 7-7 3h-8l-9-3-8-5-5-6-3-8v-11l4-11 7-6-7 2-12-1-8-4-8-8-4-11v-8l3-10 7-8 9-5 3-1h10l8 2 7 5 3 3z"
          fill="#030303"
        />
      )}
      {done && (
        <path
          transform="translate(140,292)"
          d="m0 0h11l10 4 9 9 3 6v14l-3 9-6 7 12-1 6 1 9 5 7 9 3 8v11l-6 12-7 6-7 3-3 1h-7l-13-4-6-6-1 1-1 16-5 1-4-1-1-18-5 6-9 4-5 1h-8l-10-4-7-6-5-10-1-5v-7l3-9 9-10 7-4 11-1 8 2-6-7-3-5-1-15 4-10 6-7 6-4z"
          fill="#030303"
        />
      )}
      <path
        transform="translate(46,425)"
        d="m0 0h1l1 1523 3 20 6 12 9 10 10 7 11 4 10 1h1274l14-2 9-4 9-6 7-7 6-11 3-10 1-8 1-1 1-12h1v22l-4 12-7 11-9 9-10 6-13 4-15 1h-85l-1191-1-13-4-11-7-5-5-7-8-6-13-2-11v-1531z"
        fill="#323232"
      />
      <path
        transform="translate(1423,94)"
        d="m0 0h1v1860l-3-1v-1857z"
        fill="#717171"
      />
      <path
        transform="translate(46,425)"
        d="m0 0h1l1 1523 3 20 6 12 9 10 10 7 11 4 10 1v1l-13 1-12-5-11-8-8-10-6-13-2-11v-1531z"
        fill="#262626"
      />
      <path
        transform="translate(45,90)"
        d="m0 0 3 1v1857h-1l-1-1522h-1z"
        fill="#6E6E6E"
      />
      <path
        transform="translate(1308,1859)"
        d="m0 0h29l1 4-10 35-4 16-2-1-12-45z"
        fill="#FEFEFE"
      />
      <path
        transform="translate(145,134)"
        d="m0 0 2 1 13 49 1 4h-30l2-9 9-34z"
        fill="#FEFEFE"
      />
      <path
        transform="translate(1422,1941)"
        d="m0 0h1v22l-4 12-7 11-9 9-10 6-13 4-15 1h-85l-137-1 1-2 227-1 14-2 9-4 9-6 7-7 6-11 3-10 1-8 1-1z"
        fill="#323232"
      />
      <path
        transform="translate(88,43)"
        d="m0 0h157v2l-153 1-12 3-11 6-8 7-8 13-3 8-2 8-1 9h-1v-17l5-12 6-9 5-6 10-7 12-5z"
        fill="#414141"
      />
      <path
        transform="translate(1422,1941)"
        d="m0 0h1v22l-4 12-7 11-9 9-10 6-9 3h-2l-1-3 10-3 11-7 8-8 6-11 3-10 1-8 1-1z"
        fill="#454545"
      />
      <path
        transform="translate(1384,44)"
        d="m0 0 9 3 10 6 11 11 8 16 1 4v13l-2-1-3-15-4-9-6-9-8-8-14-7-3-2z"
        fill="#3F3F3F"
      />
      <path
        transform="translate(49,1968)"
        d="m0 0h2l6 12 9 10 10 7 11 4 10 1v1l-13 1-12-5-11-8-8-10-5-10z"
        fill="#383838"
      />
      <path
        transform="translate(1423,94)"
        d="m0 0h1v53l-3 1v-52z"
        fill="#626262"
      />
      <path
        transform="translate(1409,1986)"
        d="m0 0v3l-9 8-12 6-6 1-1-3 10-3 15-9z"
        fill="#3E3E3E"
      />
      <path
        transform="translate(84,44)"
        d="m0 0 8 1v1l-12 3-11 6-5 2 2-4 10-6z"
        fill="#333"
      />
      <path
        transform="translate(50,76)"
        d="m0 0 1 4-3 11-1 9h-1v-17l2-6z"
        fill="#383838"
      />
      <path
        transform="translate(1422,1941)"
        d="m0 0h1v19l-3 3v-9l1-1z"
        fill="#3A3A3A"
      />
      <path
        transform="translate(78 2e3)"
        d="m0 0 9 1 10 1v1l-13 1-6-2z"
        fill="#3A3A3A"
      />
      <path
        transform="translate(1420,83)"
        d="m0 0 3 1v13l-2-1-1-4z"
        fill="#464646"
      />
      <path
        transform="translate(49,1968)"
        d="m0 0h2l4 8v3h-3l-4-8z"
        fill="#323232"
      />
      <path
        transform="translate(67,1994)"
        d="m0 0 6 1 7 4-4 2-9-6z"
        fill="#2C2C2C"
      />
      <path
        transform="translate(62,56)"
        d="m0 0 3 1-6 8-4 1 2-4z"
        fill="#393939"
      />
      <path
        transform="translate(1409,1986)"
        d="m0 0v3l-8 7h-3l1-3 6-3z"
        fill="#242424"
      />
      <path
        transform="translate(1413,1981)"
        d="m0 0 1 2-4 4-6 5-2-1 8-8z"
        fill="#3D3D3D"
      />
    </svg>
  );
}
